import { FETCH_PLAIN_GROUPS } from '../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_PLAIN_GROUPS:
			return action.payload;
		default:
			return state;
	}
};
